module.exports={
	"Form": "ObservationManifestEditManifest",
	"Scope": "ObservationManifest-Edit",
	"Descriptors":
	{
		"ObservationManifestDetails.IDObservationManifest":
		{
			"Name": "ID",
			"Hash": "ObsManifestEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsManifestEditIdentity",
				"Group": "ObsManifestEditIdentity"
			}
		},
		"ObservationManifestDetails.GUIDObservationManifest":
		{
			"Name": "GUID",
			"Hash": "ObsManifestEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ObsManifestEditIdentity",
				"Group": "ObsManifestEditIdentity"
			}
		},
		"ObservationManifestDetails.Name":
		{
			"Name": "Name",
			"Hash": "ObsManifestEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ObsManifestEditIdentity",
				"Group": "ObsManifestEditIdentity"
			}
		},
		"ObservationManifestDetails.DisplayName":
		{
			"Name": "Display Name",
			"Hash": "ObsManifestEdit-DisplayName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 6,
				"Section": "ObsManifestEditConfig",
				"Group": "ObsManifestEditConfig"
			}
		},
		"ObservationManifestDetails.Category":
		{
			"Name": "Category",
			"Hash": "ObsManifestEdit-Category",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 6,
				"Section": "ObsManifestEditConfig",
				"Group": "ObsManifestEditConfig"
			}
		},
		"ObservationManifestDetails.SettingsJSON":
		{
			"Name": "Settings (JSON)",
			"Hash": "ObsManifestEdit-Settings",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "ObsManifestEditSettings",
				"Group": "ObsManifestEditSettings"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsManifestEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsManifestEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "ObsManifestEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "ObsManifestEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Settings",
			"Hash": "ObsManifestEditSettings",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Settings",
					"Hash": "ObsManifestEditSettings",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
